//-- Copyright (c) 2021 TMT Insights Group, LLC
import PolarisIcon from '@/components/_common/PolarisIcon';
import styled from '@emotion/styled';
import { Box, BoxProps } from '@mui/material';

export interface BoolIconProps {
  checked?: boolean;
  label?: string;
  displayUnknown?: boolean;
  small?: boolean;
  sx?: BoxProps['sx'];
}

const BoolIcon = ({ checked, label = '', displayUnknown = false, small = false, sx }: BoolIconProps) => {
  const getIcon = () => {
    if (checked === undefined && displayUnknown) {
      return 'question_outline';
    } else if (checked) {
      return 'complete';
    }
    return 'close_outline';
  };

  return (
    <StyledBox sx={sx}>
      <StyledIcon icon={getIcon()} checked={checked} height={small ? 16 : 20} />
      {label && <label style={{ opacity: checked ? 1 : 0.5 }}>{label}</label>}
    </StyledBox>
  );
};
export default BoolIcon;

const StyledBox = styled(Box)`
  display: inline-flex;
  align-items: center;
  & > label {
    margin: 0;
    margin-left: ${({ theme }) => theme.spacing(1)};
  }
`;

const StyledIcon = styled(PolarisIcon)<{ checked?: boolean }>`
  display: block;
  font-size: 1.6rem;
  line-height: 1;
  color: ${({ theme }) => theme.palette.text.disabled};
  ${({ checked, theme }) => checked && `color: ${theme.palette.primary.light};`}
`;
